<template>
  <label
    ref="$input"
    class="bear-input"
    spellcheck="false"
    autocapitalize="false"
    autocomplete="off"
    :contenteditable="!disabled"
    :style="style"
    @focus="onFocus"
    @paste="onPaste"
    @input="onInput"
    >{{ modelValue }}</label
  >
</template>
<script>
import utils from "../../common/js/utils";
export default {
  name: "BearInput",
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: [Boolean, Function],
      default: false,
    }
  },
  computed: {
    inputWidth () {
      const { inputWidth = '' } = this.attrs
      if (inputWidth) return { display: "inline-block", width: inputWidth, minWidth: 0 }
      return null
    },
    maxText () {
      const { fontSize } = this
      const { minWidth = '' } = this.attrs
      const width = minWidth ? minWidth.replace(/\D/g, '') - 5 : 90
      return width / fontSize
    },
    style() {
      const { textLength, maxText, inputWidth } = this
      const { minWidth = '' } = this.attrs
      if (inputWidth) {
        return inputWidth
      } else {
        if (textLength > maxText) {
          return {
            minWidth: minWidth || "100px"
          }
        } else {
          return { display: "inline-block", minWidth: minWidth || "100px" }
        }
      }
    },
    textLength() {
      return utils.getTextLength(this.modelValue || "") / 2
    }
  },
  data() {
    return {
      fontSize: 16
    }
  },
  mounted () {
    this.fontSize = getComputedStyle(this.$refs.$input).fontSize.replace(/\D/g, '')
  },
  methods: {
    onPaste(e) {
      e.preventDefault()
      let txt = ""
      let range = null
      if (window.clipboardData && window.clipboardData.getData) {
        // 获取拷贝进剪切板指定格式的数据 (此处用的Text格式)
        txt = window.clipboardData.getData("Text")
      } else if ((e.clipboardData || e.originalEvent.clipboardData) && (e.clipboardData || e.originalEvent.clipboardData).getData) {
        txt = (e.originalEvent || e).clipboardData.getData("text/plain")
      }
      range = window.getSelection().getRangeAt(0)
      range.deleteContents()
      let pasteTxt = document.createTextNode(txt)
      range.insertNode(pasteTxt)

      this.$nextTick(() => {
        range.collapse(false)
        this.$emit("input")
      });
      this.onInput()
    },
    onInput() {
      let value = this.$refs.$input.innerText
      this.$emit("update:modelValue", value)
    },
    onFocus() {
      this.$emit("focus")
    }
  }
}
</script>
<style lang="scss" scoped>
.bear-input {
  position: relative;
  z-index: 1;
  text-indent: 0;
  word-break: break-all;
  line-height: 1;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  cursor: text;
  text-align: left;
  outline: none;
  color: #2393e4;
  border-bottom: 1px solid black;
  &[contenteditable="false"] {
    background: #eee;
    &:before {
      content: "";
      display: inline-block;
    }
  }
}
</style>
<style lang="scss">
.tender-form-item {
  .el-form--inline .el-form-item {
    margin-right: 0;
  }
  .is-error {
    .bear-input {
      border-bottom: 1px solid red;
      & + .el-form-item__error {
        position: relative;
        display: inline;
        padding: 5px 5px;
        background: #efdede;
        border-bottom: 1px solid red;
        border-radius: 0 3px 0 0;
      }
    }
  }
}
</style>